<template>
  <div class="card">
    <div
      v-if="this.errosGerais.Message"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            {{ this.errosGerais.Message }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-header border-bottom-0">
      <h3 class="card-title">
        <img
          src="media/icons/duotune/coding/cod003.svg"
          class="me-2"
        />Conversões
      </h3>
    </div>
    <div class="card-body pt-5">
      <div class="stepper stepper-pills" id="kt_stepper_conversao">
        <div class="stepper-nav flex-center flex-wrap mb-10">
          <div class="stepper-item mx-8 my-4" data-kt-stepper-element="nav">
            <div class="stepper-wrapper d-flex align-items-center">
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">1</span>
              </div>
              <div class="stepper-label">
                <h3 class="stepper-title">Passo 1</h3>

                <div class="stepper-desc">Tabela</div>
              </div>
            </div>
            <div class="stepper-line h-40px"></div>
          </div>
          <div class="stepper-item mx-8 my-4" data-kt-stepper-element="nav">
            <div class="stepper-wrapper d-flex align-items-center">
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">2</span>
              </div>
              <div class="stepper-label">
                <h3 class="stepper-title">Passo 2</h3>
                <div class="stepper-desc">Importação</div>
              </div>
            </div>
            <div class="stepper-line h-40px"></div>
          </div>
          <div class="stepper-item mx-8 my-4" data-kt-stepper-element="nav">
            <div class="stepper-wrapper d-flex align-items-center">
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">3</span>
              </div>
              <div class="stepper-label">
                <h3 class="stepper-title">Passo 3</h3>
                <div class="stepper-desc">Validação</div>
              </div>
            </div>
            <div class="stepper-line h-40px"></div>
          </div>
          <div class="stepper-item mx-8 my-4" data-kt-stepper-element="nav">
            <div class="stepper-wrapper d-flex align-items-center">
              <div class="stepper-icon w-40px h-40px">
                <i class="stepper-check fas fa-check"></i>
                <span class="stepper-number">4</span>
              </div>
              <div class="stepper-label">
                <h3 class="stepper-title">Passo 4</h3>
                <div class="stepper-desc">Finalização</div>
              </div>
            </div>
            <div class="stepper-line h-40px"></div>
          </div>
        </div>
        <div
          class="form d-flex flex-column align-items-center mx-auto"
          id="kt_stepper_form"
        >
          <div
            class="col-12 w-xxl-700px w-xl-800px p-1 p-sm-10 p-md-10 p-lg-10 p-xl-10 p-xxl-10"
            data-kt-stepper-element="content"
          >
            <div class="form w-100">
              <div class="col-12 mb-2">
                <div
                  class="card border border-rounded border-gray-300 mb-4 p-6"
                >
                  <h4 class="text-primary ms-4 mb-4">Tabelas</h4>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-7 col-lg-12 col-xl-7 col-xxl-7 mb-4"
                    >
                      <div class="fv-row mb-4">
                        <label class="form-label me-4"
                          >Selecione a tabela à ser convertida</label
                        >
                        <Multiselect
                          :id="`multiselectTabela`"
                          :ref="`multiselectTabela`"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Selecione a tabela à ser convertida"
                          v-model="this.tabelaSelecionada"
                          :searchable="true"
                          :canDeselect="true"
                          :options="this.camposOrdenados(this.tabelas)"
                          placeholder="Nenhuma tabela foi selecionada"
                          @clear="this.focusSelect(`multiselectTabela`)"
                        >
                          <template v-slot:singlelabel="{ value }">
                            <div class="multiselect-single-label">
                              {{ value.label }}
                            </div>
                          </template>
                          <template v-slot:option="{ option }">
                            {{ option.label }}
                          </template>
                          <template v-slot:noresults="{}">
                            <div class="m-4">
                              {{ "Nenhum resultado foi encontrado" }}
                            </div>
                          </template>
                        </Multiselect>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-5 col-lg-12 col-xl-5 col-xxl-5 mb-4"
                    >
                      <div class="fv-row mb-4">
                        <label class="form-label me-4"
                          >Selecione o tipo da conversão</label
                        >
                        <select
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Selecione o tipo da conversão"
                          class="form-select form-select-sm mb-0"
                          data-placeholder="Selecione o tipo da conversão"
                          v-model="this.tipoConversao"
                        >
                          <option value="Simplificada">Simplificada</option>
                          <!-- <option value="Detalhada">Detalhada</option> -->
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 w-xxl-700px w-xl-800px p-1 p-sm-10 p-md-10 p-lg-10 p-xl-10 p-xxl-10"
            data-kt-stepper-element="content"
          >
            <div class="form w-100">
              <div class="col-auto mb-2">
                <div
                  class="card border border-rounded border-gray-300 mb-4 p-6"
                >
                  <h4 class="text-primary ms-4 mb-4">
                    {{ `Importação Simplificada - ${this.tabelaSelecionada}` }}
                  </h4>
                  <div class="row">
                    <div class="col-auto mb-4">
                      <button
                        @click="this.baixarModeloConversao()"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        :title="`Baixar planilha de modelo de conversão da tabela ${this.tabelaSelecionada}`"
                        class="btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white"
                      >
                        <i class="fas fa-download me-2 fs-3"></i>Baixar planilha
                        de modelo
                        {{ this.tabelaSelecionada }}
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                    >
                      <div
                        class="fv-row text-center bg-light-secondary rounded border-secondary border-2 border-dashed p-3"
                      >
                        <el-upload
                          ref="uploadRef"
                          :id="`uploadRef`"
                          action="#"
                          :on-exceed="handleLimitExceed"
                          :before-remove="handleRemove"
                          v-model:file-list="this.arquivosTabelas"
                          :auto-upload="false"
                          :multiple="false"
                          drag
                          :limit="1"
                          :disabled="disableUpload"
                        >
                          <el-icon class="el-icon--upload"
                            ><upload-filled
                          /></el-icon>
                          <div class="el-upload__text">
                            Solte a planilha de conversão de
                            {{ this.tabelaSelecionada }} aqui ou
                            <em>clique para fazer o upload</em>
                          </div>
                        </el-upload>
                        <div class="mt-6">
                          Envie o arquivo .xlsx ou .xls do modelo para
                          conversão.
                          <br />Permitido somente
                          <b class="text-primary">1 arquivo</b> por conversão
                          simplificada.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 pb-10 pt-10" data-kt-stepper-element="content">
            <div class="form w-100">
              <div class="col-auto mb-2">
                <div
                  class="card border border-rounded border-gray-300 mb-4 p-6"
                >
                  <h4 class="text-primary ms-4 mb-4">Validação de Dados</h4>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                    >
                      <div
                        class="notice d-flex bg-light-info rounded border-info border border-dashed mb-4 p-6"
                      >
                        <span class="svg-icon svg-icon-2tx svg-icon-info me-4">
                          <inline-svg
                            src="media/icons/duotune/general/gen044.svg"
                          />
                        </span>
                        <div class="d-flex flex-stack flex-grow-1">
                          <div class="fw-bold">
                            <div class="text-gray-800 fw-bolder">
                              Observações importantes:
                            </div>
                            <div class="fs-7 text-gray-600 mt-2">
                              • Para gerar um código automaticamente basta
                              deixar o campo código zerado.
                              <div v-if="this.tabelaSelecionada == 'Produto'">
                                • Para vincular um grupo ao produto é necessário
                                cadastrar o grupo antes. <br />• A tributação
                                deve ser revisada antes de finalizar a
                                conversão.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <KTDatatableConversao
                        v-if="this.dadosConversao.length > 0"
                        :data="this.dadosConversao"
                        :model="model"
                        :isloading="this.loading"
                        :emptyTableText="'Nenhum cadastro encontrado'"
                        :sortable="true"
                        :orderHeaders="false"
                        :enableEdicao="true"
                        :enableItemsPerPageDropdown="true"
                        :errosValidacao="errosValidacao"
                        :errosValidacaoGeral="errosValidacaoGeral"
                        :page-sizes="pageSizes"
                        :rowsPerPage="10"
                      ></KTDatatableConversao>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 pb-10 pt-10" data-kt-stepper-element="content">
            <div class="form w-100">
              <div class="col-auto mb-2">
                <div
                  class="card border border-rounded border-gray-300 mb-4 p-6"
                >
                  <h4 class="text-primary ms-4 mb-4">Revisão de Dados</h4>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                    >
                      <KTDatatableConversao
                        v-if="this.dadosConvertidos.length > 0"
                        :data="this.dadosConvertidos"
                        :model="model"
                        :isloading="this.loading"
                        :emptyTableText="'Nenhum cadastro encontrado'"
                        :sortable="true"
                        :orderHeaders="false"
                        :enableEdicao="false"
                        :enableItemsPerPageDropdown="true"
                        :errosValidacao="errosValidacao"
                        :errosValidacaoGeral="errosValidacaoGeral"
                        :page-sizes="pageSizes"
                        :rowsPerPage="10"
                      ></KTDatatableConversao>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 w-xxl-700px w-xl-800px d-flex flex-stack">
            <div class="me-2">
              <button
                type="button"
                class="btn btn-light btn-active-light-primary"
                data-kt-stepper-action="previous"
              >
                Voltar
              </button>
            </div>
            <div>
              <button
                @click="submitConversao"
                type="button"
                class="btn btn-primary"
                data-kt-stepper-action="submit"
                v-bind:data-kt-indicator="loading ? 'on' : 'off'"
              >
                <span class="indicator-label"> Converter </span>
                <span class="indicator-progress">
                  Aguarde...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-kt-stepper-action="next"
                v-bind:data-kt-indicator="loading ? 'on' : 'off'"
              >
                <span class="indicator-label"> Próximo </span>
                <span class="indicator-progress">
                  Aguarde...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalConversao'"
    :mensagem="this.loadingMensagem"
    :mensagemSinalR="mensagemCarregamento[guidCarregamentoDados]"
    :animationJSON="null"
    v-if="this.loading === true"
  ></LoadingModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import Multiselect from "@vueform/multiselect";
import KTDatatableConversao from "@/components/kt-datatable/KTDatatableConversao.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { StepperComponent } from "@/assets/ts/components";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { UploadFilled } from "@element-plus/icons-vue";
import * as XLSX from "xlsx/xlsx";
import { mensagemCarregamento } from "@/utils/signalrHub";

const guidCarregamentoDados = "52943e60-af5f-4c86-acbc-661e3140da7b";

const produtoInicializado = {
  codigo: 0,
  nome: "",
  preco: 0,
  preco_custo: 0,
  ean: "",
  padrao_barras: "EAN13",
  und: "UN",
  und_c: "UN",
  ncm: "",
  caracteristica: "",
  id_grupo: 0,
  id: 0,
  id_adicional: null,
  descricao: "",
  inf_adicionais: "",
  preco_promocao: 0,
  promocao_tipo: "0",
  promocao_ativa: "0",
  promocao_dias_semana: "0",
  percentual_desconto: 0,
  serve_pessoas: "0",
  peso: 0,
  imagem: "",
  imagemRemover: "",
  formFile: null,
  cod_referencia: "",
  ativo: "1",
  guid: "",
  ordem: 0,
  id_subgrupo: null,
  data_alteracao_preco: null,
  data_ultima_compra: null,
  data_ultima_venda: null,
  fator: "NULO",
  id_categoria: null,
  local_armazenado: "",
  nome_no_fornecedor: "",
  outro_preco_venda: 0,
  peso_liquido: 0,
  prazo_distribuidora: 0,
  preco_custo_medio: 0,
  preco_distribuidora: 0,
  preco_prazo_revenda: 0,
  preco_revenda: 0,
  preco_ultima_compra: 0,
  preco_venda_prazo: 0,
  qtd_maxima: 0,
  qtd_minima: 0,
  qtd_parcelas: "0",
  sincronizar_pedv_mobile: "0",
  tamanho: "",
  tipo: "",
  usuario_alterou: null,
  usa_variacao: "0",
  Estoque: [
    {
      id: 0,
      id_produto: 0,
      ean: "",
      qtd: 0,
      cod_referencia: "",
      guid: "",
      preco: 0,
      data_fabricacao: null,
      data_vencimento: null,
      lote: "",
    },
  ],
  ProdutoTributacao: {
    id: 0,
    id_produto: 0,
    tipo_tributacao: "Normal",
    st: "000",
    csosn: "0102",
    classificacao_fiscal: "",
    icms: "00,00",
    mva: 0,
    reducao: 0,
    cst_ipi: "53",
    ipi: 0,
    pis_st: "49",
    pis_aliq: 0,
    pis_base: 0,
    pis_subs: 0,
    pis_subs_base: 0,
    cofins_st: "49",
    cofins_aliq: 0,
    cofins_base: 0,
    cofins_subs: 0,
    cofins_subs_base: 0,
    cfop: 5102,
    cod_genero: "0",
    cod_tipo_sped: "00",
    aliqi: "00,00",
    id_estoque_st: null,
    cod_anp: "",
    por_imposto_prod: 0,
    cest: "0000000",
    aliq_fcp: 0,
    formula_base_st: "",
    formula_icms_st: "",
    cod_servico: "",
    p_gnn: 0,
    p_glp: 0,
    p_gni: 0,
    v_part: 0,
  },
  ProdutoSimulador: {
    id: 0,
    id_produto: 0,
    preco_custo: 0,
    preco_ultima_compra: 0,
    utiliza_custo: "1",
    ipi_compra: 0,
    ipi_venda: 0,
    comissao: 0,
    outros: 0,
    frete: 0,
    operacional: 0,
    lucro_venda: 0,
    lucro_revenda: 0,
    preco_venda: 0,
    preco_revenda: 0,
    icm_venda: 0,
    icm_compra: 0,
    mao_de_obra: 0,
    desconto: 0,
    preco_venda_desconto: 0,
  },
  ProdutoAdicional: {
    id: 0,
    id_produto: 0,
    tipo_produto: "Normal",
    lote: "",
    data_validade: null,
    cod_fabricante: "",
    data_cadastro: null,
    aplicacao: "",
    similaridade: "",
    cod_fornecedor: "",
    nome_fornecedor: "",
    utiliza_lotes: "0",
    id_conta: null,
    id_custo: null,
    dun14: "",
    dun14_ean13: "",
    utiliza_dun14_nfe: "0",
  },
};

const produtoSimplificado = [
  {
    codigo: 1,
    nome: "PRODUTO TESTE",
    preco: 10,
    preco_custo: 5,
    ean: "7885180936270",
    padrao_barras: "EAN13",
    und: "UN",
    und_c: "UN",
    ncm: "00000000",
    caracteristica: "",
    id_grupo: 0,
    Estoque: [
      {
        qtd: 0,
      },
    ],
    ProdutoTributacao: {
      st: "000",
      csosn: "0102",
      icms: "00,00",
      mva: 0,
      reducao: 0,
      cst_ipi: "53",
      ipi: 0,
      pis_st: "49",
      pis_aliq: 0,
      cofins_st: "49",
      cofins_aliq: 0,
      cfop: 5102,
      aliqi: "00,00",
    },
  },
  {
    codigo: 2,
    nome: "PRODUTO TESTE 2",
    preco: 15,
    preco_custo: 10,
    ean: "736532728623",
    padrao_barras: "EAN13",
    und: "UN",
    und_c: "UN",
    ncm: "00000000",
    caracteristica: "",
    id_grupo: 0,
    Estoque: [
      {
        qtd: 0,
      },
    ],
    ProdutoTributacao: {
      st: "060",
      csosn: "0500",
      icms: "00,00",
      mva: 0,
      reducao: 0,
      cst_ipi: "53",
      ipi: 0,
      pis_st: "49",
      pis_aliq: 0,
      cofins_st: "49",
      cofins_aliq: 0,
      cfop: 5405,
      aliqi: "00,00",
    },
  },
];

const produtoSchema = {
  codigo: {
    descricao: "código",
    tipo: "Int64",
    tipoComplementar: null,
  },
  nome: {
    descricao: "nome",
    tipo: "String",
    tipoComplementar: null,
  },
  preco: {
    descricao: "preço",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  preco_custo: {
    descricao: "preço de custo",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  ean: {
    descricao: "EAN",
    tipo: "String",
    tipoComplementar: null,
  },
  padrao_barras: {
    descricao: "padrão barras",
    tipo: "String",
    tipoComplementar: null,
  },
  und: {
    descricao: "unidade",
    tipo: "String",
    tipoComplementar: null,
  },
  und_c: {
    descricao: "unidade de compra",
    tipo: "String",
    tipoComplementar: null,
  },
  ncm: {
    descricao: "ncm",
    tipo: "String",
    tipoComplementar: null,
  },
  caracteristica: {
    descricao: "característica",
    tipo: "String",
    tipoComplementar: null,
  },
  id_grupo: {
    descricao: "id do grupo",
    tipo: "Int64",
    tipoComplementar: null,
  },
  "Estoque[0].qtd": {
    descricao: "quantidade",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  "ProdutoTributacao.st": {
    descricao: "st",
    tipo: "String",
    tipoComplementar: null,
  },
  "ProdutoTributacao.csosn": {
    descricao: "csosn",
    tipo: "String",
    tipoComplementar: null,
  },
  "ProdutoTributacao.icms": {
    descricao: "icms",
    tipo: "Decimal",
    tipoComplementar: "String",
  },
  "ProdutoTributacao.mva": {
    descricao: "mva",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  "ProdutoTributacao.reducao": {
    descricao: "redução",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  "ProdutoTributacao.cst_ipi": {
    descricao: "cst do ipi",
    tipo: "String",
    tipoComplementar: null,
  },
  "ProdutoTributacao.ipi": {
    descricao: "ipi",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  "ProdutoTributacao.pis_st": {
    descricao: "st do pis",
    tipo: "String",
    tipoComplementar: null,
  },
  "ProdutoTributacao.pis_aliq": {
    descricao: "alíquota do pis",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  "ProdutoTributacao.cofins_st": {
    descricao: "st do cofins",
    tipo: "String",
    tipoComplementar: null,
  },
  "ProdutoTributacao.cofins_aliq": {
    descricao: "alíquota do cofins",
    tipo: "Decimal",
    tipoComplementar: null,
  },
  "ProdutoTributacao.cfop": {
    descricao: "cfop",
    tipo: "Int32",
    tipoComplementar: null,
  },
  "ProdutoTributacao.aliqi": {
    descricao: "alíquota interna",
    tipo: "Decimal",
    tipoComplementar: "String",
  },
};

const grupoInicializado = {
  id: 0,
  codigo: 0,
  descricao: "",
  ativo: "1",
  guid: "",
  cod_referencia: "",
  imagem: "",
  formFile: null,
  imagemRemover: "",
};

const grupoSimplificado = [
  {
    codigo: 1,
    descricao: "GRUPO TESTE",
  },
  {
    codigo: 2,
    descricao: "GRUPO TESTE 2",
  },
];

const grupoSchema = {
  codigo: {
    descricao: "código",
    tipo: "Int64",
    tipoComplementar: null,
  },
  descricao: {
    descricao: "descrição",
    tipo: "String",
    tipoComplementar: null,
  },
};

const clienteInicializado = {
  id: 0,
  codigo: 0,
  nome: "",
  fantasia: "",
  cpf_cnpj: "",
  rg_ie: "",
  inscricao_municipal: "",
  nao_contribuinte: "0",
  contato: "",
  fisica: "F",
  tipo: "C",
  ativo: "1",
  site: "",
  foto: "",
  nome_mae: "",
  nome_pai: "",
  apelido: "",
  conjuge: "",
  profissao: "",
  data_nascimento: null,
  data_casamento: null,
  observacoes: "",
  spc: "",
  guid: "",
  conceder_credito: "0",
  limite_credito: 0,
  dia_acerto: 0,
  formFile: null,
  fotoRemover: "",
  suframa: "",
  ClienteEndereco: [
    {
      id: 0,
      id_cliente: 0,
      descricao: "Casa",
      endereco: "",
      complemento: "",
      bairro: "",
      numero: "",
      cep: "",
      cidade: "",
      cod_cidade: "",
      uf: "SP",
      pais: "",
      cod_pais: "",
      latitude: "",
      longitude: "",
      cpf_cnpj: "",
    },
  ],
  ClienteTelefone: [
    {
      id: 0,
      id_cliente: 0,
      descricao: "Celular",
      telefone: "",
    },
  ],
  ClienteEmail: [
    {
      id: 0,
      id_cliente: 0,
      descricao: "Pessoal",
      email: "",
    },
  ],
};

const clienteSimplificado = [
  {
    codigo: 1,
    nome: "CLIENTE TESTE",
    fantasia: "GATEWAY",
    cpf_cnpj: "00000000000000",
    rg_ie: "00000000000",
    contato: "",
    ClienteEndereco: [
      {
        endereco: "Av. Nisshimbo do Brasil",
        numero: "531",
        complemento: "Gateway",
        bairro: "Central Parque 4L",
        cep: "18200000",
        uf: "SP",
        cod_cidade: "3552205",
        cidade: "ITAPETININGA",
        pais: "BRASIL",
        cod_pais: "1058",
      },
    ],
    ClienteTelefone: [
      {
        telefone: "(15) 3271-3786",
      },
      {
        telefone: "(15) 99999-9999",
      },
    ],
    ClienteEmail: [
      {
        email: "contato@gatewaysistemas.com.br",
      },
    ],
  },
  {
    codigo: 2,
    nome: "CLIENTE TESTE PESSOA FISICA",
    fantasia: "GATEWAY",
    cpf_cnpj: "00000000000",
    rg_ie: "000000000",
    contato: "",
    ClienteEndereco: [
      {
        endereco: "Av. Nisshimbo do Brasil",
        numero: "531",
        complemento: "Gateway",
        bairro: "Central Parque 4L",
        cep: "18200000",
        uf: "SP",
        cod_cidade: "3552205",
        cidade: "ITAPETININGA",
        pais: "BRASIL",
        cod_pais: "1058",
      },
    ],
    ClienteTelefone: [
      {
        telefone: "(15) 3271-3786",
      },
      {
        telefone: "(15) 99999-9999",
      },
    ],
    ClienteEmail: [
      {
        email: "contato@gatewaysistemas.com.br",
      },
    ],
  },
];

const clienteSchema = {
  codigo: {
    descricao: "código",
    tipo: "Int64",
    tipoComplementar: null,
  },
  nome: {
    descricao: "nome",
    tipo: "String",
    tipoComplementar: null,
  },
  fantasia: {
    descricao: "fantasia",
    tipo: "String",
    tipoComplementar: null,
  },
  cpf_cnpj: {
    descricao: "cpf/cnpj",
    tipo: "String",
    tipoComplementar: null,
  },
  rg_ie: {
    descricao: "rg/ie",
    tipo: "String",
    tipoComplementar: null,
  },
  contato: {
    descricao: "contato",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].endereco": {
    descricao: "endereço",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].numero": {
    descricao: "número",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].complemento": {
    descricao: "complemento",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].bairro": {
    descricao: "bairro",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].cep": {
    descricao: "cep",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].uf": {
    descricao: "uf",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].cod_cidade": {
    descricao: "código da cidade",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].cidade": {
    descricao: "cidade",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].pais": {
    descricao: "país",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEndereco[0].cod_pais": {
    descricao: "código do país",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteTelefone[0].telefone": {
    descricao: "telefone",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteTelefone[1].telefone": {
    descricao: "telefone",
    tipo: "String",
    tipoComplementar: null,
  },
  "ClienteEmail[0].email": {
    descricao: "email",
    tipo: "String",
    tipoComplementar: null,
  },
};

const fornecedorInicializado = {
  id: 0,
  codigo: 0,
  nome: "",
  fantasia: "",
  cpf_cnpj: "",
  rg_ie: "",
  contato: "",
  fisica: "J",
  tipo_regime: "0",
  ativo: "1",
  site: "",
  foto: "",
  observacoes: "",
  guid: "",
  id_conta: null,
  id_custo: null,
  formFile: null,
  fotoRemover: "",
  FornecedorEndereco: [
    {
      id: 0,
      id_fornecedor: 0,
      descricao: "Casa",
      endereco: "",
      complemento: "",
      bairro: "",
      numero: "",
      cep: "",
      cidade: "",
      cod_cidade: "",
      uf: "SP",
      pais: "",
      cod_pais: "",
      latitude: "",
      longitude: "",
    },
  ],
  FornecedorTelefone: [
    {
      id: 0,
      id_fornecedor: 0,
      descricao: "Celular",
      telefone: "",
    },
  ],
  FornecedorEmail: [
    {
      id: 0,
      id_fornecedor: 0,
      descricao: "Pessoal",
      email: "",
    },
  ],
};

const fornecedorSimplificado = [
  {
    codigo: 1,
    nome: "FORNECEDOR TESTE",
    fantasia: "GATEWAY",
    cpf_cnpj: "00000000000000",
    rg_ie: "00000000000",
    contato: "",
    FornecedorEndereco: [
      {
        endereco: "Av. Nisshimbo do Brasil",
        numero: "531",
        complemento: "Gateway",
        bairro: "Central Parque 4L",
        cep: "18200000",
        uf: "SP",
        cod_cidade: "3552205",
        cidade: "ITAPETININGA",
        pais: "BRASIL",
        cod_pais: "1058",
      },
    ],
    FornecedorTelefone: [
      {
        telefone: "(15) 3271-3786",
      },
      {
        telefone: "(15) 99999-9999",
      },
    ],
    FornecedorEmail: [
      {
        email: "contato@gatewaysistemas.com.br",
      },
    ],
  },
  {
    codigo: 2,
    nome: "FORNECEDOR TESTE PESSOA FISICA",
    fantasia: "GATEWAY",
    cpf_cnpj: "00000000000",
    rg_ie: "000000000",
    contato: "",
    FornecedorEndereco: [
      {
        endereco: "Av. Nisshimbo do Brasil",
        numero: "531",
        complemento: "Gateway",
        bairro: "Central Parque 4L",
        cep: "18200000",
        uf: "SP",
        cod_cidade: "3552205",
        cidade: "ITAPETININGA",
        pais: "BRASIL",
        cod_pais: "1058",
      },
    ],
    FornecedorTelefone: [
      {
        telefone: "(15) 3271-3786",
      },
      {
        telefone: "(15) 99999-9999",
      },
    ],
    FornecedorEmail: [
      {
        email: "contato@gatewaysistemas.com.br",
      },
    ],
  },
];

const fornecedorSchema = {
  codigo: {
    descricao: "código",
    tipo: "Int64",
    tipoComplementar: null,
  },
  nome: {
    descricao: "nome",
    tipo: "String",
    tipoComplementar: null,
  },
  fantasia: {
    descricao: "fantasia",
    tipo: "String",
    tipoComplementar: null,
  },
  cpf_cnpj: {
    descricao: "cpf/cnpj",
    tipo: "String",
    tipoComplementar: null,
  },
  rg_ie: {
    descricao: "rg/ie",
    tipo: "String",
    tipoComplementar: null,
  },
  contato: {
    descricao: "contato",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].endereco": {
    descricao: "endereço",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].numero": {
    descricao: "número",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].complemento": {
    descricao: "complemento",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].bairro": {
    descricao: "bairro",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].cep": {
    descricao: "cep",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].uf": {
    descricao: "uf",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].cod_cidade": {
    descricao: "código da cidade",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].cidade": {
    descricao: "cidade",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].pais": {
    descricao: "país",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEndereco[0].cod_pais": {
    descricao: "código do país",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorTelefone[0].telefone": {
    descricao: "telefone",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorTelefone[1].telefone": {
    descricao: "telefone",
    tipo: "String",
    tipoComplementar: null,
  },
  "FornecedorEmail[0].email": {
    descricao: "email",
    tipo: "String",
    tipoComplementar: null,
  },
};

export default {
  components: {
    Multiselect,
    LoadingModal,
    UploadFilled,
    KTDatatableConversao,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  setup() {
    return { mensagemCarregamento, guidCarregamentoDados };
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async handleLimitExceed(files) {
      this.disableUpload = true;
      let alert = await this.showQuestionAlert(
        "Somente 1 arquivo é permitido por conversão simplificada! Deseja substituir o arquivo?"
      );
      this.disableUpload = false;
      if (alert.isConfirmed) {
        this.arquivosTabelas.splice(0, this.arquivosTabelas.length);
        var file = files[0];
        file.status = "ready";
        file.raw = files[0];
        this.arquivosTabelas.push(file);
      }
    },
    async handleRemove() {
      this.disableUpload = true;
      let alert = await this.showQuestionAlert("Deseja remover o arquivo?");
      this.disableUpload = false;
      if (alert.isConfirmed) {
        return true;
      } else {
        return false;
      }
    },
    async passoUm() {
      if ((await this.validarPassoUm()) === true) {
        await this.inicializarModelo();
        if (this.tipoConversao === "Simplificada") {
          var element = document.querySelector("#kt_stepper_conversao");
          var stepper = StepperComponent.getInstance(element);
          stepper.goNext();
        } else {
          await this.getSchema();
        }
      }
    },
    async validarPassoUm() {
      if (this.tabelaSelecionada === null || this.tabelaSelecionada === "") {
        await this.showInvalidAlert("Nenhuma tabela foi selecionada!");
        setTimeout(() => {
          this.focusSelect(`multiselectTabela`);
        }, 400);
        return false;
      }

      return true;
    },
    async inicializarModelo() {
      this.modeloInicializado = {};
      this.modeloSimplificado = [];
      this.model = {};
      switch (this.tabelaSelecionada) {
        case "Produto":
          this.modeloInicializado = JSON.parse(
            JSON.stringify(produtoInicializado)
          );
          this.modeloSimplificado = JSON.parse(
            JSON.stringify(produtoSimplificado)
          );
          this.model = JSON.parse(JSON.stringify(produtoSchema));
          break;
        case "Grupo":
          this.modeloInicializado = JSON.parse(
            JSON.stringify(grupoInicializado)
          );
          this.modeloSimplificado = JSON.parse(
            JSON.stringify(grupoSimplificado)
          );
          this.model = JSON.parse(JSON.stringify(grupoSchema));
          break;
        case "Cliente":
          this.modeloInicializado = JSON.parse(
            JSON.stringify(clienteInicializado)
          );
          this.modeloSimplificado = JSON.parse(
            JSON.stringify(clienteSimplificado)
          );
          this.model = JSON.parse(JSON.stringify(clienteSchema));
          break;
        case "Fornecedor":
          this.modeloInicializado = JSON.parse(
            JSON.stringify(fornecedorInicializado)
          );
          this.modeloSimplificado = JSON.parse(
            JSON.stringify(fornecedorSimplificado)
          );
          this.model = JSON.parse(JSON.stringify(fornecedorSchema));
          break;
        default:
          await this.showInvalidAlert("Nenhuma tabela foi selecionada!");
      }
    },
    async getSchema() {
      this.model = {};
      if (this.tabelaSelecionada != null && this.tabelaSelecionada != "") {
        this.loadingMensagem = "";
        this.mensagemCarregamento[guidCarregamentoDados] = "";
        await this.exibirModalLoading(true);
        let viewModel = this.tabelaSelecionada + "ViewModel";
        try {
          var ret = await this.$store.dispatch("schema/getSchema", viewModel);
          if (ret.Success === true) {
            this.model = JSON.parse(ret.Data);
            await this.exibirModalLoading(false);
            var element = document.querySelector("#kt_stepper_conversao");
            var stepper = StepperComponent.getInstance(element);
            stepper.goNext();
          }
        } catch (error) {
          await this.exibirModalLoading(false);
          if (error.Message) {
            await this.showErrorAlert(error.Message);
          }
        }
      } else {
        await this.showInvalidAlert("Nenhuma tabela foi selecionada!");
      }
    },
    async passoDois() {
      if ((await this.validarPassoDois()) === true) {
        await this.converterPlanilhas();
      }
    },
    async validarPassoDois() {
      if (this.arquivosTabelas.length === 0) {
        await this.showInvalidAlert(
          "Nenhuma planilha de conversão foi enviada!"
        );
        return false;
      }

      for (let arquivo of this.arquivosTabelas) {
        if (
          !(arquivo.name.includes(".xlsx") || arquivo.name.includes(".xls"))
        ) {
          await this.showInvalidAlert(
            "Somente arquivo .xlsx ou .xls é permitido para conversão!"
          );
          return false;
        }
      }

      return true;
    },
    async baixarModeloConversao() {
      await this.exportarExcel(this.modeloSimplificado);
    },
    async converterModeloParaDados(modelo) {
      const dados = [];
      let model = this.model;
      let utils = this.$utils;

      function gerarLinhas(objeto) {
        objeto.forEach((item) => {
          const linhaAtual = {};
          adicionarValores(item, linhaAtual);
          dados.push(linhaAtual);
        });
      }

      function adicionarValores(objeto, linhaAtual, prefixo = "") {
        Object.entries(objeto).forEach(([chave, valor]) => {
          if (Array.isArray(valor)) {
            valor.forEach((subitem, index) => {
              const novoPrefixo = `${prefixo}${chave}[${index}]`;
              adicionarValores(subitem, linhaAtual, `${novoPrefixo}.`);
            });
          } else if (typeof valor === "object" && valor !== null) {
            adicionarValores(valor, linhaAtual, `${prefixo}${chave}.`);
          } else {
            let key = `${prefixo}${chave}`;
            let value = valor;
            if (model[key]) {
              const tipo = model[key].tipoComplementar
                ? model[key].tipoComplementar
                : model[key].tipo;

              switch (tipo) {
                case "String":
                  value = valor ? valor.toString() : "";
                  break;
                case "Int32":
                  value = utils.isInteger(valor) ? parseInt(valor) : 0;
                  break;
                case "Int64":
                case "Decimal":
                  value = utils.isNumeric(valor) ? parseFloat(valor) : 0.0;
                  break;
                case "Date":
                  break;
                default:
                  break;
              }
            }
            linhaAtual[`${prefixo}${chave}`] = value;
          }
        });
      }

      gerarLinhas(modelo);

      return dados;
    },
    async exportarExcel(modelo) {
      const dados = await this.converterModeloParaDados(modelo);

      const ws = XLSX.utils.json_to_sheet(dados);

      const mapearTipoParaExcel = (tipo) => {
        switch (tipo) {
          case "String":
            return "s";
          case "Int32":
          case "Int64":
          case "Decimal":
            return "n";
          case "Date":
            return "d";
          default:
            return "s";
        }
      };

      var ultimaCellAddress = "";
      for (var rowIndex = 0; rowIndex < 1000; rowIndex++) {
        Object.keys(dados[0]).forEach((key, colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({
            c: colIndex,
            r: rowIndex + 1,
          });
          if (ws[cellAddress] === undefined) {
            ws[cellAddress] = {
              v: "",
            };
          }

          const cell = ws[cellAddress];

          if (this.model[key]) {
            const tipo = this.model[key].tipoComplementar
              ? this.model[key].tipoComplementar
              : this.model[key].tipo;
            cell.t = mapearTipoParaExcel(tipo);

            if (tipo === "Date" && cell.v) {
              cell.v = new Date(cell.v);
            }

            if (tipo === "String" && typeof cell.v === "string") {
              cell.z = "@";
            }

            if (tipo === "Decimal") {
              cell.z = "#,##0.00";
            }

            if (tipo === "Int32" || tipo === "Int64") {
              cell.z = "#,##0";
            }

            if (
              this.model[key].tipo === "Decimal" &&
              this.model[key].tipoComplementar === "String"
            ) {
              cell.z = "00.00";
            }
          }

          ultimaCellAddress = cellAddress;
        });
      }

      ws["!ref"] = `A1:${ultimaCellAddress}`;

      const colunas = [];

      Object.keys(dados[0]).forEach((chave) => {
        const comprimentoNome = chave.length;

        const comprimentoValor = dados.reduce((maxLength, item) => {
          const valor = item[chave];
          const length = valor ? valor.toString().length : 0;
          return Math.max(maxLength, length);
        }, 0);

        const comprimentoMaior = Math.max(comprimentoNome, comprimentoValor);
        colunas.push({ wch: comprimentoMaior + 2 });
      });

      ws["!cols"] = colunas;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.tabelaSelecionada);
      XLSX.writeFile(wb, `${this.tabelaSelecionada.toLowerCase()}.xlsx`);
    },
    async converterPlanilhas() {
      this.errosGerais = {};
      this.errosValidacao = {};
      this.errosValidacaoGeral = [];
      this.dadosConversao.splice(0, this.dadosConversao.length);
      this.dadosConvertidos.splice(0, this.dadosConvertidos.length);
      this.loadingMensagem = "Realizando a leitura dos dados da planilha";
      await this.exibirModalLoading(true);
      var planilhas = {
        conversaoViewModel: [],
      };
      for (var item of this.arquivosTabelas) {
        if (item.status === "ready") {
          item.formFile = item.raw;
          planilhas.conversaoViewModel.push(item);
        }
      }

      var formData = this.$utils.convertModelToFormData(planilhas);
      try {
        var ret = await this.$store.dispatch(
          "conversao/converterPlanilha",
          formData
        );
        if (ret.Success === true) {
          this.loadingMensagem = "Realizando a leitura do retorno dos dados";
          this.mensagemCarregamento[guidCarregamentoDados] = "";
          await this.sleep(100);
          let dados = JSON.parse(JSON.stringify(ret.Data));
          let dadosInicializados = await this.converterDadosParaModelo(
            dados,
            JSON.parse(JSON.stringify(this.modeloInicializado))
          );
          if (this.tipoConversao === "Simplificada") {
            this.dadosConversao.push(
              ...(await this.converterModeloParaDados(dadosInicializados))
            );
          } else {
            this.dadosConversao.push(
              ...JSON.parse(JSON.stringify(dadosInicializados))
            );
          }
          await this.exibirModalLoading(false);
          this.loadingMensagem = "";
          this.mensagemCarregamento[guidCarregamentoDados] = "";
          await this.showSuccessAlert(ret.Message);
          var element = document.querySelector("#kt_stepper_conversao");
          var stepper = StepperComponent.getInstance(element);
          stepper.goNext();
        } else {
          await this.exibirModalLoading(false);
          this.loadingMensagem = "";
          this.mensagemCarregamento[guidCarregamentoDados] = "";
          await this.showErrorAlert(ret.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        this.loadingMensagem = "";
        this.mensagemCarregamento[guidCarregamentoDados] = "";
        await this.showErrorAlert(
          error && error.Message ? error.Message : error
        );
      }
    },
    async converterDadosParaModelo(dadosExcel, modelo) {
      function adicionarValores(objeto, chave, valor) {
        const partes = chave.split(".");
        let obj = objeto;
        for (let i = 0; i < partes.length - 1; i++) {
          const parte = partes[i];
          if (parte.endsWith("]")) {
            const [nomeArray, indice] = parte.split("[");
            const arrayIndex = parseInt(indice.slice(0, -1));
            if (obj[nomeArray] != undefined) {
              obj = obj[nomeArray];

              if (!obj[arrayIndex]) {
                let objModelo = JSON.parse(JSON.stringify(modelo));
                let objArray = objModelo[nomeArray];
                obj[arrayIndex] = objArray ? objArray[0] : {};
              }
              obj = obj[arrayIndex];
            }
          } else {
            if (obj[parte] != undefined) {
              obj = obj[parte];
            }
          }
        }
        if (obj[partes[partes.length - 1]] != undefined) {
          obj[partes[partes.length - 1]] = valor;
        }
      }

      const modelosConvertidos = [];

      dadosExcel.forEach((linha) => {
        const objeto = JSON.parse(JSON.stringify(modelo));

        Object.entries(linha).forEach(([chave, valor]) => {
          adicionarValores(objeto, chave, valor);
        });

        if ("guid" in objeto) {
          if (objeto.guid === null || objeto.guid === "") {
            objeto.guid = this.$utils.generateUuidv4();
          }
        }

        if (this.tabelaSelecionada === "Produto") {
          if (objeto.ProdutoTributacao) {
            objeto.ProdutoTributacao.icms =
              objeto.ProdutoTributacao.icms.toString();
            objeto.ProdutoTributacao.aliqi =
              objeto.ProdutoTributacao.aliqi.toString();
          }
        }

        modelosConvertidos.push(objeto);
      });

      return modelosConvertidos;
    },
    async passoTres() {
      this.loadingMensagem = "Preparando os dados para validação";
      await this.exibirModalLoading(true);
      let dados = await this.converterDadosParaModelo(
        this.dadosConversao,
        JSON.parse(JSON.stringify(this.modeloInicializado))
      );
      await this.validarDados(dados);
    },
    async validarDados(dados) {
      this.errosGerais = {};
      this.errosValidacao = {};
      this.errosValidacaoGeral = [];
      this.loadingMensagem = "Validando os dados para conversão";
      await this.sleep(100);
      var store = `${this.tabelaSelecionada.toLowerCase()}/validate`;
      try {
        var ret = await this.$store.dispatch(store, dados);
        if (ret.Success === true) {
          this.loadingMensagem = "Realizando a leitura do retorno dos dados";
          this.mensagemCarregamento[guidCarregamentoDados] = "";
          await this.sleep(100);
          let dadosValidados = JSON.parse(JSON.stringify(ret.Data));
          this.dadosConvertidos.splice(0, this.dadosConvertidos.length);
          if (this.tipoConversao === "Simplificada") {
            this.dadosConvertidos.push(
              ...(await this.converterModeloParaDados(dadosValidados))
            );
          } else {
            this.dadosConvertidos.push(
              ...JSON.parse(JSON.stringify(dadosValidados))
            );
          }
          await this.exibirModalLoading(false);
          this.loadingMensagem = "";
          this.mensagemCarregamento[guidCarregamentoDados] = "";
          await this.showSuccessAlert(ret.Message);
          var element = document.querySelector("#kt_stepper_conversao");
          var stepper = StepperComponent.getInstance(element);
          stepper.goNext();
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        this.loadingMensagem = "";
        this.mensagemCarregamento[guidCarregamentoDados] = "";
        this.errosValidacaoGeral.push(
          ...this.$utils.retornarValoresJsonAtalhoSimples(error)
        );
        this.errosGerais = error;
        this.errosValidacao = error;
      }
    },
    async submitConversao() {
      this.loadingMensagem = "Preparando os dados para conversão";
      await this.exibirModalLoading(true);
      let dados = await this.converterDadosParaModelo(
        this.dadosConvertidos,
        JSON.parse(JSON.stringify(this.modeloInicializado))
      );
      await this.iniciarConversao(dados);
    },
    async iniciarConversao(dados) {
      this.errosGerais = {};
      this.errosValidacao = {};
      this.errosValidacaoGeral = [];
      this.loadingMensagem = "Seus dados estão sendo convertidos";
      await this.sleep(100);
      var store = `${this.tabelaSelecionada.toLowerCase()}/converter`;
      try {
        var ret = await this.$store.dispatch(store, dados);
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          this.loadingMensagem = "";
          this.mensagemCarregamento[guidCarregamentoDados] = "";
          await this.showSuccessAlert(ret.Message);
          var element = document.querySelector("#kt_stepper_conversao");
          var stepper = StepperComponent.getInstance(element);
          stepper.goFirst();
          this.dadosConversao.splice(0, this.dadosConversao.length);
          this.dadosConvertidos.splice(0, this.dadosConvertidos.length);
          this.arquivosTabelas.splice(0, this.arquivosTabelas.length);
          this.tabelaSelecionada = "";
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        this.loadingMensagem = "";
        this.mensagemCarregamento[guidCarregamentoDados] = "";
        this.errosValidacaoGeral.push(
          ...this.$utils.retornarValoresJsonAtalhoSimples(error)
        );
        this.errosGerais = error;
        this.errosValidacao = error;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async focusSelect(campo) {
      await this.sleep(100);
      var element = this.$refs[campo];
      if (element) {
        element.open();
      }
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalConversao");
        await this.sleep(1000);
      } else {
        await this.sleep(500);
        hideModalId("loadingModalConversao");
        await this.sleep(1000);
        this.loading = false;
      }
    },
    async showQuestionAlert(text) {
      return await Swal.fire({
        text: text,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "ENTER - Sim",
        cancelButtonText: "ESC - Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        html: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showErrorAlert(text) {
      await Swal.fire({
        text: text,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    camposOrdenados(objeto) {
      const compararPorDescricao = (a, b) => {
        const descricaoA = a.descricao.toUpperCase();
        const descricaoB = b.descricao.toUpperCase();

        if (descricaoA < descricaoB) return -1;
        if (descricaoA > descricaoB) return 1;
        return 0;
      };

      const objetoOrdenado = objeto.sort((a, b) => compararPorDescricao(a, b));

      const transformedJson = [];
      for (const key in objetoOrdenado) {
        transformedJson.push({
          value: objetoOrdenado[key].descricao,
          label: objetoOrdenado[key].descricao,
          objeto: objetoOrdenado[key],
        });
      }

      return transformedJson;
    },
  },
  async mounted() {
    var element = document.querySelector("#kt_stepper_conversao");
    var stepper = new StepperComponent(element);

    stepper.on("kt.stepper.next", async (event) => {
      if (stepper.currentStepIndex === 1) {
        await this.passoUm();
      } else if (stepper.currentStepIndex === 2) {
        await this.passoDois();
      } else if (stepper.currentStepIndex === 3) {
        await this.passoTres();
      }
    });

    stepper.on("kt.stepper.previous", function (event) {
      stepper.goPrev();
    });

    stepper.goto(2);
    stepper.goto(1);

    setTimeout(() => {
      this.focusSelect(`multiselectTabela`);
    }, 400);
  },
  data() {
    return {
      loadingMensagem: "",
      modeloInicializado: {},
      modeloSimplificado: [],
      dadosConversao: [],
      dadosConvertidos: [],
      arquivosTabelas: [],
      disableUpload: false,
      tipoConversao: "Simplificada",
      loading: false,
      timeOut: null,
      model: {},
      errosGerais: {},
      errosValidacao: {},
      errosValidacaoGeral: [],
      tabelaSelecionada: "",
      tabelas: [
        {
          descricao: "Produto",
        },
        {
          descricao: "Grupo",
        },
        {
          descricao: "Cliente",
        },
        {
          descricao: "Fornecedor",
        },
      ],
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "1000"],
    };
  },
};
</script>

<style scoped>
.multiselect > * {
  font-size: 0.925rem;
  border-radius: 0.425rem;
  font-weight: 500;
  line-height: 1.5;
}
.multiselect-option.is-pointed.is-selected {
  background: hwb(219 31% 26%);
}
.multiselect-option.is-selected {
  background: hwb(219 31% 26%);
}
.is-single .multiselect-search input {
  padding: 0px 0px 0px 14px;
  font-size: 0.925rem;
}
.multiselect-input {
  min-height: 34px;
}
.multiselect-single-label {
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap !important;
  padding-right: 10px !important;
}
.multiselect-input input {
  min-height: 34px;
}
.multiselect-clear {
  position: absolute;
  right: 4px;
  top: 50%;
  width: 34px;
  height: 34px;
  background: transparent;
}
</style>
